import { Button } from "../../../designSystems/components/Button"
import leftArrow from "../../../assets/img/icons/left-arrow-white.svg"
import illustraMap from '../../../assets/img/illustra-map.svg'
import fundacaoMboi from '../../../assets/img/fundacao-mboi.svg'
import { FiEye, FiEyeOff } from "react-icons/fi"
import { useNavigate } from "react-router"
import { Container } from "./style"
import { useContext, useEffect, useRef, useState } from "react"
import { Form } from "semantic-ui-react"
import { login } from "../../../api/authentication"
import { useForm, SubmitHandler } from "react-hook-form";
import { GlobalContext } from "../../../context/GlobalContext"

type Props = {
    email: string
    password: string
}

export const LoginPage = (): JSX.Element => {
    const { register, handleSubmit, watch, formState: { errors } } = useForm<Props>(
        { defaultValues: { email: '', password: '' } }
    );
    const [currentUser, setCurrentUser] = useState<'user' | 'admin'>('user')
    const currentUserRef = useRef<'user' | 'admin'>('user')
    const [showPassword, setShowPassword] = useState(false)
    const { setDataToast, setUserId } = useContext(GlobalContext)

    const navigate = useNavigate()

    useEffect(() => { }, [])

    const goToPage = (path: string): void => {
        navigate(path)
    }

    const selectAccess = (role: 'user' | 'admin'): void => {
        currentUserRef.current = role
        setCurrentUser(role)
    }

    const onSubmit: SubmitHandler<Props> = data => {
        const result = { ...data, is_admin: currentUserRef.current === 'admin' }

        login(result).then((data: any) => {
            localStorage.removeItem('first-info')
            localStorage.setItem(data.data.user.is_admin ? 'authentication-admin' : 'usuario', JSON.stringify(data.data))
            setUserId(data.data.user.id)
            goToPage('/admin')
        }).catch(err => {
            const message = err?.response?.data?.message
            const textError = !message || message === 'Unauthorized'
                ? 'E-mail ou senha incorretos.'
                : message
            setDataToast({ show: true, text: textError, type: 'error' })
        })
    }

    return (
        <Container>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6">
                        <div className="left-content">
                            <div className="btn-back">
                                <Button
                                    text={'Voltar ao mapa'}
                                    icon={leftArrow}
                                    height="42px"
                                    type="button"
                                    background="transparent"
                                    className="radius-8 float-left btn-register"
                                    onClick={(event) => {
                                        event.preventDefault()
                                        goToPage('/mapa')
                                    }}
                                />
                            </div>

                            <div className="login-container">
                                <div className="title-content">Faça o seu Login</div>
                                <p className="subtitle">Acesse as iniciativas da zona sul de São Paulo.</p>

                                <div className="login">
                                    <div className="d-block text-center">
                                        <div className="title">Mapa PerifaSul</div>
                                        <div className="type-users" role="group" aria-label="Tipo de acesso">
                                            <div className={`bg-type ${currentUser === 'user' ? 'user active' : 'admin active'}`}></div>
                                            <button
                                                type="button"
                                                className={`type ${currentUser === 'user' ? 'selected' : ''}`}
                                                aria-pressed={currentUser === 'user'}
                                                onClick={() => selectAccess('user')}
                                            >
                                                Usuário
                                            </button>
                                            <button
                                                type="button"
                                                className={`type ${currentUser === 'admin' ? 'selected' : ''}`}
                                                aria-pressed={currentUser === 'admin'}
                                                onClick={() => selectAccess('admin')}
                                            >
                                                Administrador
                                            </button>
                                        </div>
                                        <div>
                                            <form
                                                className="ui form"
                                                onSubmit={(event) => {
                                                    event.preventDefault()
                                                    void handleSubmit(onSubmit)(event)
                                                }}
                                            >
                                                <Form.Input label='Login *' placeholder='exemplo@exemplo.com'>
                                                    <input className={errors.email && 'error'} {...register("email", { required: true })} />
                                                </Form.Input>
                                                {errors.email && <p className="field-error-msg">Campo obrigatório</p>}

                                                <Form.Input label='Senha *' type={showPassword ? 'text' : 'password'} placeholder='Senha'>
                                                    <input
                                                        type={showPassword ? 'text' : 'password'}
                                                        className={errors.password && 'error'}
                                                        placeholder='Senha'
                                                        {...register("password", { required: true })}
                                                    />
                                                    <button
                                                        className="img-icon flex-cc"
                                                        type="button"
                                                        aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                                                        onClick={() => setShowPassword((visible) => !visible)}
                                                    >
                                                        {showPassword ? <FiEye size={18} /> : <FiEyeOff size={18} />}
                                                    </button>
                                                </Form.Input>
                                                {errors.password && <p className="field-error-msg">Campo obrigatório</p>}

                                                <Button className="btn-submit radius-100" type="submit" text="Entrar" />
                                                <Button
                                                    hasShadow={false}
                                                    className="btn-forget"
                                                    type="button"
                                                    background="transparent"
                                                    text="Esqueci minha senha"
                                                    onClick={(event) => {
                                                        event.preventDefault()
                                                        goToPage('/solicitar-nova-senha')
                                                    }}
                                                />
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 stage">
                        <div className="right-content">
                            <img className="map" src={illustraMap} alt="Mapa da zona sul de São Paulo" />
                            <img className="brand" src={fundacaoMboi} alt="Fundo Comunitário PerifaSul M'Boi" />
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}